import { Box, Button, Card, Container, Input, InputBase, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Popover, MenuItem, Select, TableHead, CircularProgress, DialogContentText, FormControl, InputLabel, OutlinedInput, Chip, Tabs, Tab, Grid } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Iconify from 'src/components/iconify';
import { getData, postData, putData, uploadFile } from 'src/webService/webService';
import { toast } from 'react-toastify';
import PaginationComponent from 'src/components/pagination';
import wordIcon from '../../components/logo/icons-word.png'
import pdfIcon from '../../components/logo/icons-pdf.png'
import { file_URL } from '../../utils/url'

function VideoEditingSelfAssigned() {

    const [open, setOpen] = useState(null);
    const [editingTasks, setEditingTasks] = useState([]);
    const [formOpen, setFormOpen] = useState(false);
    const [dailyData, setDailyData] = useState("");
    const [editRow, setEditRow] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [updateLead, setUpdateLead] = useState();
    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [view, setView] = useState([]);
    const [details, setDetails] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);
    const descriptionElementRef = useRef(null);
    const [selectedLead, setSelectedLead] = useState("");
    const [scroll, setScroll] = useState('paper');
    const [allUpdates, setAllUpdates] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState({})
    const [fileUpload, setFileUpload] = useState(null);
    const [selectedWorkUpdateId, setSelectedWorkUpdateId] = useState(null);
    const [convertForm, setConvertForm] = useState(false);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [assignedLeads, setAssignedLeads] = useState([]);
    const [openImage, setOpenImage] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [activeTab, setActiveTab] = useState(0);
    const [events, setEvents] = useState([]);
    const [graphicId, setGraphicId] = useState("");
    const [socialId, setSocialId] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [editingData, setEditingData] = useState([]);

    const [formData, setFormData] = useState({
        projectName: "",
        rawFootageUpload: "",
        editingType: "",
        editingSoftwareUsed: "",
        editingProgress: "",
        comments: "",
        deadline: "",
        teamCommunicationNotes: "",
        status: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleOpenMenu = (event, task, id, workUpdateId) => {
        // const lead = assignedLeads.find((data) => data._id === id);
        // if (event?.currentTarget) {
        //     setOpen(event.currentTarget);
        //     setSelectedLeadId(id);
        //     setSelectedLead(lead);
        //     setSelectedWorkUpdateId(workUpdateId)
        //     setView(task);
        // }
        let lead;
        if (task && typeof task === 'object') {
            lead = task;
            setSelectedLead(lead);
        }
        else {
            lead = assignedLeads.find((data) => data._id === id);
            setSelectedLead(lead);
        }

        if (event?.currentTarget) {
            setOpen(event.currentTarget);
            setSelectedLeadId(id);
            setSelectedWorkUpdateId(workUpdateId);
            setView(task);
            setSelectedLead(lead);
        }
    };

    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handleOpenDialog = async () => {
        await getAllUpdatesAdmin();
        setDetails(true);
        handleCloseMenu();
    };

    const handleCloseDialog = () => {
        setDetails(false);
    };

    const handleOpen = async () => {
        setFormOpen(true);
        handleCloseMenu();
    }

    const handleClose = () => {
        setFormOpen(false)
    }

    useEffect(() => {
        if (details) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [details]);

    const sessionToken = sessionStorage.getItem("Token");
    const role = sessionStorage.getItem("role");
    const roleType = sessionStorage.getItem("roleType");
    const serviceTeamType = sessionStorage.getItem("serviceTeamType");
    const UserId = sessionStorage.getItem('userId');

    const getAllUsers = async () => {
        try {
            const params = { page: 1, limit: 1000 };
            const response = await getData("users/users", params);
            console.log("Response:", response);

            let filteredUsers = [];

            if (role === "Admin") {
                filteredUsers = response.data.results.filter(user =>
                    user.serviceTeamType &&
                    (user.serviceTeamType.includes("Social Media") ||
                        user.serviceTeamType.includes("Graphic Designing")) &&
                    user.roleType === "Team Leader"
                );
            } else if (roleType === "Team Leader") {
                filteredUsers = response.data.results.filter(user =>
                    user.serviceTeamType && user.serviceTeamType.includes("Video Editing")
                );
            }

            const formattedOptions = filteredUsers.map(user => ({
                id: user._id,
                name: user.name
            }));

            setEmployeeOptions(formattedOptions);
        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error(`Failed to load users ${error ? error : ''}`);
        }
    };

    const getDailyUpdates = async () => {

        try {
            const response = await getData(`dailyworkupdates/user/${UserId}`, {}, sessionToken);
            console.log("Response Daily Updates:", response)
            const results = response?.data;
            console.log("Results:", results)
            setDailyData(results);

        } catch (err) {
            console.error("Error while fetching Website Designing Team:", err);
            toast.error(`Failed to load Website Designing Team. ${err ? err : ''}`);
        }

    }

    const getAllUpdatesAdmin = async () => {

        const params = {
            page: 1,
            limit: 1000
        }

        try {
            const response = await getData("dailyworkupdates/updates", params, sessionToken);
            console.log("Response Dailyyy Updates:", response)

            const filteredData = response?.data[0]?.paginatedResults?.filter(lead => lead.serviceName === "Video Editing");

            console.log("Filtered Data:", filteredData);
            setAllUpdates(filteredData); // Store all data here
            // setView(filteredData);

        } catch (err) {
            console.error("Error while fetching Content Creation Team:", err);
            toast.error(`Failed to load Content Creation Team. ${err ? err : ''}`);
        }

    }

    const handleFileChange = (event, leadId) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
            handleFileUpload(file, leadId);
        }
    };

    const handleFileUpload = async (fileupload, leadId) => {
        console.log("Fileupload:", fileupload);
        console.log("Is File:", fileupload instanceof File);

        const formDataToSend = new FormData();
        formDataToSend.append("file", fileupload);

        try {
            const response = await uploadFile(`files/upload/${selectedLeadId}`, formDataToSend);
            if (response?.status === 200) {
                toast.success("File uploaded successfully!");
                setFileUpload(response?.data);
                setFormData(prevState => ({
                    ...prevState,
                    fileupload: response?.data,
                }));
            } else {
                toast.error("File upload failed!", response?.message);
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error(`Error uploading file. ${error ? error : ''}`);
        }
    };

    const postDailyWorkUpdates = async () => {
        debugger

        try {

            const checkResponse = await getData(`dailyworkupdates/${selectedLeadId}`, {}, sessionToken);
            const existingUpdates = checkResponse?.data?.flatMap(update => update?.videoEditingHistory?.map(history => history?.dailyUpdateId));

            const videoEditingHistory = selectedLead?.videoEditingHistory?.[0] ||
                selectedLead?.videoEditingHistory ||
                {};
            const assignedEditingShots = selectedLead?.videoEditingHistory?.[0]?.assignedEditingShots;
            const previousCompleted = videoEditingHistory.completedEditingShots || 0;
            const newCompleted = parseInt(formData.completedEditingShots, 10) || 0;
            const totalCompleted = previousCompleted + newCompleted;
            const remainingShots = assignedEditingShots - newCompleted;

            const editingType = selectedLead?.videoEditingHistory?.[0]?.editingType ||
                selectedLead?.videoEditingHistory?.editingType ||
                '';

            const deadline = selectedLead?.videoEditingHistory?.[0]?.deadline ||
                selectedLead?.videoEditingHistory?.deadline ||
                '';

            const totalEditingShots = selectedLead?.videoEditingHistory?.[0]?.totalEditingShots ||
                selectedLead?.videoEditingHistory?.totalEditingShots;

            const amount = selectedLead?.videoEditingHistory?.[0]?.amount ||
                selectedLead?.videoEditingHistory?.amount ||
                '';
            const assignedTo = selectedLead?.videoEditingHistory?.[0]?.assignedTo ||
                selectedLead?.videoEditingHistory?.assignedTo ||
                '';
            const status = selectedLead?.videoEditingHistory?.[0]?.completedEditingShots === selectedLead?.videoEditingHistory?.[0]?.totalEditingShots ? "Completed" : "In Progress";

            const payLoad = {
                amount,
                assignedTo,
                leadId: selectedLeadId,
                editingType,
                comments: formData.comments,
                rawFootageUpload: fileUpload,
                serviceName: "Video Editing",
                deadline,
                totalEditingShots,
                completedEditingShots: totalCompleted,
                userId: UserId,
                status,
                assignedEditingShots: remainingShots
            }

            let response;

            if (existingUpdates.length === 0) {
                // POST new update if none exists
                response = await postData('dailyworkupdates', payLoad, sessionToken);
            } else {
                // PUT update existing record
                const updateId = existingUpdates[0]; // Get first update's ID
                response = await putData(`dailyworkupdates/dailyworkupdates/${updateId}`, payLoad, sessionToken);
            }

            if (response?.status === 200) {
                toast.success("Daily Work Updated Successfully!");
                handleClose();
                getDailyUpdates();
                getAllLeads();
            } else {
                throw new Error(response?.message || "Failed to update Daily Work.");
            }

        } catch (error) {
            console.error("Error:", error);
            toast.error(`${error ? error : ''}`);
        }
    }

    const getAllLeads = async (skip = currentPage, limit = 5) => {
        const parmas = {
            page: skip,
            limit: limit
        }
        try {
            console.log("Fetching users...");
            console.log("Token being sent:", sessionToken);

            const response = await getData(`leads/leads/${UserId}`, parmas, sessionToken);
            console.log("Response:", response)

            const responseData = response?.data[0]?.paginatedResults || [];

            setEditingData(responseData)
            setTotalPages(response.data[0].totalPages);
            setTotalCount(response.data[0].totalCount.totalItems);

        }
        catch (error) {
            console.error("Error fetching users:", error);
        }
    }

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        if (currentPage === 1) {
            setLimit(event.target.value)
            getAllLeads(1, event.target.value)
        }
        else {
            setCurrentPage(1);
            setLimit(event.target.value);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            getAllLeads(currentPage - 1, limit);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
            getAllLeads(currentPage + 1, limit);
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    useEffect(() => {
        getAllUsers();
        getAllUpdatesAdmin();
        getAllLeads(currentPage, limit);
        if (roleType === "Employee") {
            getDailyUpdates();
        }
    }, [role, roleType, serviceTeamType, currentPage, limit]);

    return (
        <>
            <Helmet>
                <title>Self Assigned Video Editing</title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Self Assigned Tasks
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                    </Box>
                </Stack>

                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
                    <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                        <Table>
                            <TableHead>
                                <TableCell>S.No</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Contact</TableCell>
                                <TableCell>Assigned Work</TableCell>
                                <TableCell>Deadline</TableCell>
                                <TableCell>Completed Tasks</TableCell>
                                <TableCell>File</TableCell>
                                <TableCell>Progress</TableCell>
                                <TableCell></TableCell>
                            </TableHead>
                            <TableBody>
                                {
                                    editingData?.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={9} align="center">
                                                No data found
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        editingData?.map((work, id) => {
                                            return (
                                                <TableRow key={work?.id}>
                                                    <TableCell>{calculateIndex(id)}</TableCell>
                                                    <TableCell>{work?.name}</TableCell>
                                                    <TableCell>{work?.phone}</TableCell>
                                                    <TableCell>{work?.currentWork?.noOfPosters}</TableCell>
                                                    <TableCell>{work?.currentWork !== null ? new Date(work?.currentWork?.deadline).toLocaleDateString() : "-"}</TableCell>
                                                    <TableCell>{work?.videoEditingHistory[0]?.completedEditingShots} / {work?.videoEditingHistory[0]?.totalEditingShots}</TableCell>
                                                    <TableCell>
                                                        {work?.videoEditingHistory[0]?.rawFootageUpload?.path ?
                                                            <img
                                                                src={work?.videoEditingHistory[0]?.rawFootageUpload?.path
                                                                    ? `${file_URL + encodeURI(work?.videoEditingHistory[0]?.rawFootageUpload?.path.replace("public/", ""))}`
                                                                    : "#"}
                                                                alt='Image.png'
                                                                style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                onClick={() => {
                                                                    const fullImage = work?.videoEditingHistory[0]?.rawFootageUpload?.path
                                                                        ? `${file_URL + encodeURI(work?.videoEditingHistory[0]?.rawFootageUpload?.path.replace("public/", ""))}`
                                                                        : "#";
                                                                    setSelectedImage(fullImage);
                                                                    setOpenImage(true);
                                                                }}
                                                            />
                                                            : "-"}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Box position="relative" display="inline-flex">
                                                            <CircularProgress
                                                                variant="determinate"
                                                                value={work?.videoEditingHistory[0]?.progress}
                                                            />
                                                            <Box
                                                                top={0}
                                                                left={0}
                                                                bottom={0}
                                                                right={0}
                                                                position="absolute"
                                                                display="flex"
                                                                alignItems="center"
                                                                justifyContent="center"
                                                            >
                                                                <Typography variant="caption" component="div" color="text.secondary">
                                                                    {typeof work?.videoEditingHistory[0]?.progress === 'number'
                                                                        ? `${Math.round(work.videoEditingHistory[0].progress)}%`
                                                                        : '0%'}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Iconify
                                                            icon="material-symbols-light:more-vert"
                                                            sx={{ margin: "auto" }}
                                                            onClick={(event) => handleOpenMenu(event, work, work._id, work?.videoEditingHistory[0]?.dailyUpdateId)}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <PaginationComponent
                        name={"Leads"}
                        totalcount={totalCount}
                        limit={limit}
                        handleLimitChange={handleLimitChange}
                        handlePrevPage={handlePrevPage}
                        handleNextPage={handleNextPage}
                        currentPage={currentPage}
                        totalPages={totalPages}
                    />
                </Card>

                {/* Dialog for Adding Task */}
                <Dialog open={formOpen} onClose={() => setFormOpen(false)}>
                    <DialogTitle>Daily Work Update</DialogTitle>
                    <DialogContent>
                        <TextField
                            name="completedEditingShots"
                            label="Completed Tasks"
                            type="number"
                            fullWidth
                            margin="dense"
                            value={formData.completedEditingShots}
                            onChange={handleChange}
                        />
                        {/* <TextField
                            name="status"
                            label="Status"
                            fullWidth
                            select
                            margin="dense"
                            value={formData.status}
                            onChange={handleChange}
                        >
                            <MenuItem value="Pending">Pending</MenuItem>
                            <MenuItem value="In Progress">In Progress</MenuItem>
                            <MenuItem value="Completed">Completed</MenuItem>
                        </TextField> */}
                        <TextField
                            margin='dense'
                            type='file'
                            hidden
                            label="Upload File"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleFileChange(e)}
                        >
                        </TextField>
                        <TextField
                            margin="dense"
                            label="Comments"
                            name="comments"
                            value={formData.comments}
                            onChange={handleChange}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setFormOpen(false)} color="secondary">Cancel</Button>
                        <Button color="primary" onClick={postDailyWorkUpdates}>Update</Button>
                    </DialogActions>
                </Dialog>

                {/* Edit Menu  */}
                <Popover
                    open={Boolean(open)}
                    anchorEl={open}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    <>
                        <MenuItem onClick={handleOpenDialog}>
                            <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                            View
                        </MenuItem>
                        <MenuItem onClick={handleOpen}>
                            <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                            Work Update
                        </MenuItem>
                    </>
                </Popover>

                <Dialog
                    open={details}
                    onClose={handleCloseDialog}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    sx={{ maxWidth: 700, width: "100%", margin: "0 auto" }}
                >
                    <DialogTitle id="scroll-dialog-title">
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                            Daily Work Updates
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            component="div"
                        >
                            {!view || Object.keys(view).length === 0 ? (
                                <Box sx={{ p: 3, textAlign: 'center' }}>
                                    <Typography variant="h6" color="text.secondary">No data found</Typography>
                                </Box>
                            ) : (
                                <Box sx={{ p: 1 }}>
                                    <Paper elevation={3} sx={{
                                        p: 2,
                                        backgroundColor: '#ffffff',
                                        borderRadius: 2,
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                        borderLeft: '5px solid #1976d2' // A subtle accent line
                                    }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Project Details
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Name: {view?.name}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Deadline: {new Date(view?.videoEditingHistory?.deadline).toLocaleDateString()}
                                                </Typography>
                                            </Grid>
                                            {/* <Grid item xs={12} sm={6} id="paddingTop">
                        <Typography variant="body1">
                          Status: <Typography component="span" sx={{
                            fontWeight: 'bold',
                            color: view?.videoEditingHistory?.status === 'Completed' ? 'success.main' :
                              view?.videoEditingHistory?.status === 'In Progress' ? 'warning.main' : 'error.main'
                          }}>
                            {view?.videoEditingHistory?.status}
                          </Typography>
                        </Typography>
                      </Grid> */}
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Editing Software Used: {view?.videoEditingHistory?.editingSoftwareUsed}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Project Name: {view?.videoEditingHistory?.projectName}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Task Progress
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Completed Shots: {view?.videoEditingHistory?.completedShots}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Total Editing Shots: {view?.videoEditingHistory?.totalShots}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="body1">
                                                    Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                        {view?.videoEditingHistory?.editingProgress}%
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            {view?.[0]?.videoEditingHistory?.comments && (
                                                <Grid item xs={12} id="paddingTop">
                                                    <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#333' }}>
                                                        Comments
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                                                        "{view?.[0]?.videoEditingHistory?.comments}"
                                                    </Typography>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Timestamps
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Created: {new Date(view?.createdAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Updated: {new Date(view?.updatedAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                                            <Table sx={{ minWidth: 350 }} aria-label="customized table">
                                                <TableBody>
                                                    {/* Employee content history */}
                                                    {view?.contentCreationHistory?.length > 0 && (
                                                        <>
                                                            {/* Title Row */}
                                                            <TableRow>
                                                                <TableCell
                                                                    colSpan={4}
                                                                    align="left"
                                                                    sx={{ fontWeight: "bold", fontSize: "16px", background: "#f5f5f5" }}
                                                                >
                                                                    Content Creation History
                                                                </TableCell>
                                                            </TableRow>

                                                            {view.contentCreationHistory.map((history, hIndex) => {
                                                                const filePath = history?.fileUpload?.path?.toLowerCase() || "";
                                                                const fileUrl = history?.fileUpload?.path
                                                                    ? `${file_URL + encodeURI(
                                                                        history.fileUpload.path.replace("public/", "")
                                                                    )}`
                                                                    : null;

                                                                return (
                                                                    <TableRow
                                                                        key={`content-${hIndex}`}
                                                                        hover
                                                                        onClick={() => fileUrl && window.open(fileUrl, "_blank")}
                                                                    >
                                                                        <TableCell align="center">{hIndex + 1}</TableCell>
                                                                        <TableCell align="center">
                                                                            {fileUrl ? (
                                                                                filePath.endsWith(".docx") ? (
                                                                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                        <img src={wordIcon} alt="Word" height="40" width="40" />
                                                                                    </a>
                                                                                ) : filePath.endsWith(".pdf") ? (
                                                                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                        <img src={pdfIcon} alt="PDF" height="40" width="40" />
                                                                                    </a>
                                                                                ) : filePath.match(/\.(jpg|jpeg|png|webp|avif)$/) ? (
                                                                                    <img
                                                                                        src={fileUrl}
                                                                                        alt="Uploaded"
                                                                                        style={{ maxWidth: "40px", cursor: "pointer" }}
                                                                                    />
                                                                                ) : (
                                                                                    <span style={{ fontSize: "18px" }}>-</span>
                                                                                )
                                                                            ) : (
                                                                                "-"
                                                                            )}
                                                                        </TableCell>
                                                                        <TableCell align="center">{history?.comments || "-"}</TableCell>
                                                                        <TableCell align="center">
                                                                            {history?.updatedAt
                                                                                ? new Date(history.updatedAt).toLocaleString()
                                                                                : "-"}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                        </>
                                                    )}

                                                    {/* Camera history */}
                                                    {view?.cameraHistory?.length > 0 && (
                                                        <>
                                                            {/* Title Row */}
                                                            <TableRow>
                                                                <TableCell
                                                                    colSpan={4}
                                                                    align="left"
                                                                    sx={{ fontWeight: "bold", fontSize: "16px", background: "#f5f5f5" }}
                                                                >
                                                                    Camera History
                                                                </TableCell>
                                                            </TableRow>

                                                            {view.cameraHistory.map((history, hIndex) => {
                                                                const filePath = history?.fileUpload?.path?.toLowerCase() || "";
                                                                const fileUrl = history?.fileUpload?.path
                                                                    ? `${file_URL + encodeURI(
                                                                        history.fileUpload.path.replace("public/", "")
                                                                    )}`
                                                                    : null;

                                                                return (
                                                                    <TableRow
                                                                        key={`camera-${hIndex}`}
                                                                        hover
                                                                        onClick={() => fileUrl && window.open(fileUrl, "_blank")}
                                                                    >
                                                                        <TableCell align="center">{hIndex + 1}</TableCell>
                                                                        <TableCell align="center">
                                                                            {fileUrl ? (
                                                                                filePath.endsWith(".docx") ? (
                                                                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                        <img src={wordIcon} alt="Word" height="40" width="40" />
                                                                                    </a>
                                                                                ) : filePath.endsWith(".pdf") ? (
                                                                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                        <img src={pdfIcon} alt="PDF" height="40" width="40" />
                                                                                    </a>
                                                                                ) : filePath.match(/\.(jpg|jpeg|png|webp|avif)$/) ? (
                                                                                    <img
                                                                                        src={fileUrl}
                                                                                        alt="Uploaded"
                                                                                        style={{ maxWidth: "40px", cursor: "pointer" }}
                                                                                    />
                                                                                ) : (
                                                                                    <span style={{ fontSize: "18px" }}>-</span>
                                                                                )
                                                                            ) : (
                                                                                "-"
                                                                            )}
                                                                        </TableCell>
                                                                        <TableCell align="center">{history?.comments || "-"}</TableCell>
                                                                        <TableCell align="center">
                                                                            {history?.updatedAt
                                                                                ? new Date(history.updatedAt).toLocaleString()
                                                                                : "-"}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                        </>
                                                    )}

                                                    {/* Editing history */}
                                                    {view?.cameraHistory?.length > 0 && (
                                                        <>
                                                            {/* Title Row */}
                                                            <TableRow>
                                                                <TableCell
                                                                    colSpan={4}
                                                                    align="left"
                                                                    sx={{ fontWeight: "bold", fontSize: "16px", background: "#f5f5f5" }}
                                                                >
                                                                    Video Editing History
                                                                </TableCell>
                                                            </TableRow>

                                                            {view.videoEditingHistory.map((history, hIndex) => {
                                                                const filePath = history?.rawFootageUpload?.path?.toLowerCase() || "";
                                                                const fileUrl = history?.rawFootageUpload?.path
                                                                    ? `${file_URL + encodeURI(
                                                                        history.rawFootageUpload.path.replace("public/", "")
                                                                    )}`
                                                                    : null;

                                                                return (
                                                                    <TableRow
                                                                        key={`camera-${hIndex}`}
                                                                        hover
                                                                        onClick={() => fileUrl && window.open(fileUrl, "_blank")}
                                                                    >
                                                                        <TableCell align="center">{hIndex + 1}</TableCell>
                                                                        <TableCell align="center">
                                                                            {fileUrl ? (
                                                                                filePath.endsWith(".docx") ? (
                                                                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                        <img src={wordIcon} alt="Word" height="40" width="40" />
                                                                                    </a>
                                                                                ) : filePath.endsWith(".pdf") ? (
                                                                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                        <img src={pdfIcon} alt="PDF" height="40" width="40" />
                                                                                    </a>
                                                                                ) : filePath.match(/\.(jpg|jpeg|png|webp|avif)$/) ? (
                                                                                    <img
                                                                                        src={fileUrl}
                                                                                        alt="Uploaded"
                                                                                        style={{ maxWidth: "40px", cursor: "pointer" }}
                                                                                    />
                                                                                ) : (
                                                                                    <span style={{ fontSize: "18px" }}>-</span>
                                                                                )
                                                                            ) : (
                                                                                "-"
                                                                            )}
                                                                        </TableCell>
                                                                        <TableCell align="center">{history?.comments || "-"}</TableCell>
                                                                        <TableCell align="center">
                                                                            {history?.updatedAt
                                                                                ? new Date(history.updatedAt).toLocaleString()
                                                                                : "-"}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                        </>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Box>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={handleCloseDialog} variant="contained" color="primary">Close</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={openImage} onClose={() => setOpenImage(false)} maxWidth="md">
                    <Iconify
                        icon="material-symbols:close"
                        onClick={() => setOpenImage(false)}
                        style={{
                            position: 'absolute',
                            top: 10,
                            right: 10,
                            fontSize: 24,
                            cursor: 'pointer',
                            zIndex: 1
                        }}
                    />
                    <DialogContent>
                        <img src={selectedImage} alt="Full View" style={{ width: "100%", height: "auto" }} />
                    </DialogContent>
                </Dialog>

            </Container >
        </>
    );
}

export default VideoEditingSelfAssigned;